import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';

import { Pedido } from '../models/pedido';
import { PedidoStatusFluxo } from '../models/pedido-status-fluxo';
import { PedidoService } from '../pedido.service';

@Component({
  selector: 'app-pedido-list-finalizado',
  templateUrl: './pedido-list-finalizado.component.html',
  styleUrls: ['./pedido-list-finalizado.component.scss']
})
export class PedidoListFinalizadoComponent implements OnInit {

  public listaPedido: Pedido[];
  public displayMsg : boolean =false;
  public idPedido: string;  
  public listaStatusFluxo: PedidoStatusFluxo[] = [];
  private first = 0;
  private rows = 10;
  public statusCor = new Map<string, string>();

  constructor(public pedidoService: PedidoService, private router: Router, private messageService: MessageService
    //, private confirmationService: ConfirmationService
    ) { }

  ngOnInit(): void {

        this.getPedidos();    
        this.criarMap();
        
       
    }


    getPedidos(){

        this.pedidoService.getPedidos("F").subscribe(
            (res) => {
                if (res) {            
                    this.listaPedido = res;          
                }
            },
            err => {
                console.log("ERRO PEDDIDO-LIST");
                console.log(err);
            }
        );
    }

    editPedido(idPedido)
    {
        this.router.navigate(['/pedido', idPedido])                
    }

    printPedido(idPedido)
    {
        this.router.navigate(['/pedido-pdf', idPedido])                
    }  

    next() {
        this.first = this.first + this.rows;
    }

    prev() {
        this.first = this.first - this.rows;
    }

    reset() {
        this.first = 0;
    }

    isLastPage(): boolean {
        return this.listaPedido ? this.first === (this.listaPedido.length - this.rows): true;
    }

    isFirstPage(): boolean {
        return this.listaPedido ? this.first === 0 : true;
    }

    criarMap(){
        this.statusCor.set('TRANSMITIDO','0');
        this.statusCor.set('RECEBIDO','1');
        this.statusCor.set('FINALIZADO','2');
    }
}
